/*
 * Welcome to your app's main JavaScript file!
 *
 * We recommend including the built version of this JavaScript file
 * (and its CSS file) in your base layout (apidoc.html.twig).
 */
import { createApp } from 'vue'
import App from "./pages/App";
import VueMobileDetection from 'vue-mobile-detection'
import axios from 'axios';
import { router } from './routes'
import { createGtm } from '@gtm-support/vue-gtm';
import FloatingVue from 'floating-vue';
import VueCookies from 'vue-cookies';
import { store } from './components/stores/OpportuniteStore';
import "tailwindcss/tailwind.css";
import "@/assets/styles/mainFront.scss";
import 'floating-vue/dist/style.css'
import '@/plugins/date-fns';

export const client = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
const app = createApp(App)
app.provide('$axiosClient', client); //   const $axios = inject('$axios');  // pour injecter
app.config.globalProperties.$axios = axios; // pour les this.$axiosClient
app.use(store)
app.use(router)
app.use(FloatingVue)
app.use(VueCookies)
app.use(VueMobileDetection)

app.use(
  createGtm({
    id: process.env.VUE_APP_GTM_ID || 'GTM-PWFFJLG', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
    defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: false, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    // vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
  }),
);

//todo à supprimer une fois toutes les méthodes passé sur le useGtm
app.config.globalProperties.trackEvent = (category,action,label) => {
  app.$gtm && app.$gtm.trackEvent({
    event: 'declenche-evenement-leads', // Event type [default = 'interaction'] (Optional)
    category: category,
    action: action,
    label: label,
    noninteraction: false, // Optional
  })
}
app.mount('#app')
